export default {
	DUPLICATE_PRESENTATION: 'DuplicatePresentation',
	STORE_DOWNLOAD: 'StoreDownload',
	ADD_LOCAL_VIDEO: 'AddLocalVideo',
	ADD_YOUTUBE_VIDEO: 'AddYoutubeVideo',
	ADD_DROPBOX_VIDEO: 'AddDropboxVideo',
	ADD_DRIVE_VIDEO: 'AddGoogleDriveVideo',
	ADD_ONEDRIVE_VIDEO: 'AddOneDriveVideo',
	ADD_STORE_VIDEO: 'AddVideo',
	ADD_ACTIVITY_BANK: 'AddActivityBank',
}
